import { http } from "@dashboard/common/http";
import { AiStoreData } from "../entities/ai-service.entity";
import { camelizeKeys, decamelizeKeys } from "humps";
import { getEnvVar } from "@dashboard/common/utils";
import { selectedTemplateBody } from "./selected-template";

export const fetchGetAiStore = async (text: string): Promise<AiStoreData> => {
  const language = localStorage.getItem("i18nextLng") || "es";
  const response = await http.post(
    `${getEnvVar(
      "REACT_APP_AI_STORE_LAMBDA"
    )}/api/ms/ai-onboarding/generate/new/v3`,
    { text, ...selectedTemplateBody() },
    {
      headers: {
        "Accept-Language": language,
        "Content-Type": "application/json",
      },
    }
  );
  return camelizeKeys(response.data) as AiStoreData;
};

export const fetchRegenerateAiStore = async (
  text: string,
  token: string
): Promise<AiStoreData> => {
  const language = localStorage.getItem("i18nextLng") || "es";
  const response = await http.post(
    `${getEnvVar("REACT_APP_AI_STORE_LAMBDA")}/api/ms/ai-onboarding/regenerate`,
    { text, ...selectedTemplateBody() },
    {
      headers: {
        "Accept-Language": language,
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return camelizeKeys(response.data) as AiStoreData;
};

export const fetchMergeAiStore = async (
  ownerToken: string,
  guestToken: string
): Promise<{ status: string }> => {
  const language = localStorage.getItem("i18nextLng") || "es";
  const response = await http.post(
    `${getEnvVar("REACT_APP_AI_STORE_LAMBDA")}/api/ms/ai-onboarding/merge`,
    decamelizeKeys({ ownerToken, guestToken }),
    {
      headers: {
        "Accept-Language": language,
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

/**
 * Genera la tienda sobre un usuario YA REGISTRADO.
 *
 * Es el mismo endpoint que usaba "Ver otra opción" con el guest. Ahora es el
 * camino principal: sin usuario invitado, sin merge posterior.
 */
export const fetchBuildStore = async (text: string, token: string, ownerId: string) => {
  const language = localStorage.getItem("i18nextLng") || "es";
  const response = await http.post(
    `${getEnvVar("REACT_APP_AI_STORE_LAMBDA")}/api/ms/ai-onboarding/regenerate`,
    { text, ...selectedTemplateBody() },
    {
      headers: {
        "Accept-Language": language,
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "owner-id": ownerId,
        "api-key-sumer": getEnvVar("REACT_APP_KEY_SP"),
      },
    }
  );
  return camelizeKeys(response.data) as AiStoreData;
};
